import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  getPreferredLocale,
  LANGUAGE_RESPONSE_CACHE_HEADERS,
} from "@/lib/i18n/actions";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    // Redirect to preferred locale (cookie or browser language)
    const preferredLocale = await getPreferredLocale();
    throw redirect({
      to: "/$locale",
      params: { locale: preferredLocale },
      // This redirect target depends on the visitor's Accept-Language / cookie,
      // so it must never be stored by a shared cache and served to others.
      headers: LANGUAGE_RESPONSE_CACHE_HEADERS,
    });
  },
});